import { render, staticRenderFns } from "./submitVerifyBtn.vue?vue&type=template&id=01a58966&scoped=true&"
import script from "./submitVerifyBtn.vue?vue&type=script&lang=js&"
export * from "./submitVerifyBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a58966",
  null
  
)

export default component.exports